import { render } from "./ICMText.vue?vue&type=template&id=d054a526"
import script from "./ICMText.vue?vue&type=script&lang=js"
export * from "./ICMText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__